import { AfterViewInit, Component, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthenticationService } from '@app/core';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AffiliateService } from '@app/core/affiliate.service';
import { HttpClient } from '@angular/common/http';
import { ModalService } from '@app/shared/modal.service';
import { Subscription } from 'rxjs/Subscription';
import { JackpotService } from '@app/core/jackpot.service';
import * as amplitude from 'amplitude-js';

@Component({
  selector: 'app-active-bonuses-modal',
  template: `
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>

    <div class="label yellow-label">withdrawal is limited</div>
    <div class="_10px-spacer"></div>
    <h3>Restricted withdrawal</h3>
    <img src="/assets/images/v2/withdraw-disabled.svg" height="200" />
    <p>You have active bonuses that must be either completed or dismissed.</p>
    <a [routerLink]="['/account/bonus', { outlets: { modal: null } }]" (click)="close()">
      <app-form-button class="primary full-width">Manage</app-form-button>
    </a>
  `,
  styles: [
    `
      :host {
        text-align: center;
        align-items: center;
        display: flex;
        flex-direction: column;
      }
      .log-in-or-text {
        margin-top: 10px;
        margin-bottom: 10px;
      }
      h3 {
        margin-bottom: 0;
      }
    `,
  ],
})
export class ModalActiveBonusesComponent extends AnimatedModalComponent implements AfterViewInit {
  data: { available: number } = { available: 0 };

  constructor(
    private ref: NgbActiveModal,
    protected elRef: ElementRef,
    protected renderer: Renderer2,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected http: HttpClient
  ) {
    super(elRef, renderer);
  }

  ngAfterViewInit() {
    amplitude.getInstance().logEvent('Withdrawal - Limited');
  }

  public close(): void {
    this.ref.close(0);
  }

  public reject(): void {
    this.ref.dismiss(1);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/active-bonuses-modal.component.ts